<div *ngIf="exibirLoaderFullscreen">
  <app-loader></app-loader>
</div>

<div class="modal-window-termos" id="modal-window-termos">
  <div>
    <span
      class="fa fa-times-circle fa-2x modal-close fixed__close"
      onclick="abrirFecharPopupTermos(this, false)"
    ></span>
    <img
      src="assets/images/logos/cacaushow_horizontal.png"
      class="termos__logo"
    />
    <div class="background__login">
      <div class="align__center angular-with-newlines">
        <dynamic-form [fields]="regConfigPopupTermos"></dynamic-form>
      </div>
    </div>
  </div>
</div>
<div class="modal-window-regulamento" id="modal-window-regulamento">
  <div>
    <span
      class="fa fa-times-circle fa-2x modal-close fixed__close"
      onclick="abrirFecharPopupRegulamento(this, false)"
    ></span>
    <img
      src="assets/images/logos/cacaushow_horizontal.png"
      class="termos__logo"
    />
    <div class="background__login">
      <div class="align__center angular-with-newlines">
        <dynamic-form [fields]="regConfigPopupRegulamento"></dynamic-form>
      </div>
    </div>
  </div>
</div>
<div class="modal__cadastro__chat" *ngIf="exibePopupChatLover">
  <div>
    <span
      class="fa fa-times-circle fa-3x modal__cadastro__chat__close"
      (click)="exibePopupChatLover = false"
    ></span>
    <div>
      <div
        #chatScroll
        class="divMensagens"
        [ngClass]="{ divMensagensTermos: indexChat == 6 }"
      >
        <img
          src="assets/images/others/atendente_chat.png"
          class="chat_atendente"
        />
        <div
          class="divMensagem"
          *ngFor="let m of chatMensagens"
          [ngClass]="{ divMensagemUsuario: m.remetente == 1 }"
        >
          <div class="divMensagemTriangulo" *ngIf="m.remetente == 2"></div>
          <p>{{ m.mensagem }}</p>
        </div>
      </div>
      <div class="divChatBottom">
        <dynamic-form [fields]="regConfigCadastroCacauLover"></dynamic-form>
        <dynamic-form
          [fields]="regConfigCadastroCacauLoverTermos"
          *ngIf="indexChat == 6"
        ></dynamic-form>
        <dynamic-form
          [fields]="regConfigCadastroCacauLoverFinalizar"
          *ngIf="indexChat >= 6"
        ></dynamic-form>
        <dynamic-form
          [fields]="regConfigCadastroCacauLoverFooter"
        ></dynamic-form>
      </div>
    </div>
  </div>
</div>
<div class="saiba_mais">
  <div class="chat_icone">
    <dynamic-form [fields]="regConfigChatIcon"></dynamic-form>
  </div>
  <div class="cabecalho image image__saiba_mais_cabecalho">
    <div class="cabecalho__cacaulovers_beneficios">
      <div class="labels">
        <dynamic-form [fields]="regConfigBeneficiosLabel"></dynamic-form>
      </div>
      <div class="beneficios_baloes">
        <div class="beneficio-precos">
          <dynamic-form [fields]="regConfigBeneficiosPrecos"></dynamic-form>
        </div>
        <div class="beneficio-promocoes">
          <dynamic-form [fields]="regConfigBeneficiosPromocoes"></dynamic-form>
        </div>
        <div class="beneficio-cashback">
          <dynamic-form [fields]="regConfigBeneficiosCashback"></dynamic-form>
        </div>
        <div class="beneficio-experiencias">
          <dynamic-form
            [fields]="regConfigBeneficiosExperiencias"
          ></dynamic-form>
        </div>
      </div>
      <div class="beneficio-outros">
        <dynamic-form [fields]="regConfigBeneficiosOutros"></dynamic-form>
      </div>
    </div>
    <div class="transicao1"></div>
    <!-- <div class="cabecalho__chocolate">
            <img class="image chocolate__imagem_mobile" src="assets/images/others/chocolate_escorrendo_mobile.png">
            <img class="image chocolate__imagem_desktop" src="assets/images/others/chocolate_escorrendo.png">
        </div> -->
  </div>
  <div class="divCadastroCacauLover image image__saiba_mais_cadastro">
    <div class="transicao2"></div>
    <dynamic-form [fields]="regConfigCadastroLover"></dynamic-form>
    <div class="divCadastroLoverCampos">
      <dynamic-form
        [fields]="regConfigCadastroLoverCampos1"
        [hidden]="etapaAtual != 1"
        id="dinamicForm1"
      >
      </dynamic-form>
      <dynamic-form
        [fields]="regConfigCadastroLoverCampos2"
        [hidden]="etapaAtual != 2"
        id="dinamicForm2"
      >
      </dynamic-form>
      <dynamic-form
        [fields]="regConfigCadastroLoverCampos3"
        [hidden]="etapaAtual != 3"
        id="dinamicForm3"
      >
      </dynamic-form>
      <dynamic-form
        [fields]="regConfigCadastroLoverCampos4"
        [hidden]="etapaAtual != 4"
        id="dinamicForm4"
      >
      </dynamic-form>
      <dynamic-form
        [fields]="regConfigCadastroLoverCampos5"
        [hidden]="etapaAtual != 5"
        id="dinamicForm5"
      >
      </dynamic-form>
      <dynamic-form
        [fields]="regConfigCadastroLoverCampos6"
        [hidden]="etapaAtual != 6"
        id="dinamicForm6"
      >
      </dynamic-form>
    </div>
    <div class="divCadastroLoverCamposRodape">
      <dynamic-form
        [fields]="regConfigCadastroLoverCamposRodape"
      ></dynamic-form>
    </div>
  </div>
  <div class="white_container image image__saiba_mais_whitecontainer">
    <!-- <div class="carousel_desconto">
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          'border-radius': '8px',
          height: '300px',
          width: '100%',
          'margin-top': '30px'
        }"
        *ngIf="carregandoDescontos"
      ></ngx-skeleton-loader>
      <dynamic-form
        [fields]="regDescontosParaLovers"
        *ngIf="!carregandoDescontos"
      ></dynamic-form>
    </div> -->

    <!-- <div class="saiba_mais__beneficios_quizz"> -->
    <!-- <div class="beneficios_div">
        <app-beneficios-niveis></app-beneficios-niveis>
      </div> -->
    <!-- <div class="quizz_div">
        <app-quizz
          id="quiz"
          [ExibirUsuarioNaoLogado]="true"
          [ExibirUsuarioLogado]="false"
          [ExibirTodos]="false"
          [SomenteAtivos]="true"
        ></app-quizz>
      </div> -->
    <!-- </div> -->
    <!-- <div class="milhoes_container">
            <dynamic-form [fields]="regConfigMilhoes"></dynamic-form>
        </div> -->
    <app-faq></app-faq>
  </div>
</div>
